import { TextField } from '@/components/ds2'
import { ReviewNotice } from './ReviewNotice'

interface SkipSubmitProps {
    reason: string
    onReason: (reason: string) => void
}

/**
 * Skip & submit's notice and reason (v17), for a Needs review load only: shown above the drawer's error line once Skip & submit is
 * clicked; the footer's "Confirm skip & submit" then accepts the POD exception with this reason and creates the draft. The issue stays
 * in the invoice's audit record; nothing is sent to a broker or a factoring provider. A short reason is said in a toast.
 */
export const SkipSubmit = ({ reason, onReason }: SkipSubmitProps) => (
    <section className="flex flex-col" aria-label="Skip and submit">
        <ReviewNotice tone="warning">
            <span>Submit this invoice draft with an unresolved POD exception.</span> The issue remains in the invoice audit record; this does not send anything
            to a broker or factoring provider.
        </ReviewNotice>
        <TextField
            autoFocus
            label="Reason for skipping"
            placeholder="Explain why you want to proceed"
            value={reason}
            onChange={(event) => onReason(event.target.value)}
        />
    </section>
)
